import { render, staticRenderFns } from "./ProviderDashboard.vue?vue&type=template&id=5b33b5a6&"
import script from "./ProviderDashboard.vue?vue&type=script&lang=js&"
export * from "./ProviderDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProviderDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
